import { frontendURL } from 'dashboard/helper/URLHelper';

const ExtensionsList = () => import('./pages/extensions/ExtensionsList.vue');
const ExtensionForm = () => import('./pages/extensions/ExtensionForm.vue');
const QueuesList = () => import('./pages/queues/QueuesList.vue');
const QueueForm = () => import('./pages/queues/QueueForm.vue');
const DidsList = () => import('./pages/dids/DidsList.vue');
const DidForm = () => import('./pages/dids/DidForm.vue');
const TimeConditionsList = () =>
  import('./pages/time-conditions/TimeConditionsList.vue');
const SupervisorDashboard = () =>
  import('./pages/supervisor/SupervisorDashboard.vue');
const SupervisorAgents = () =>
  import('./pages/supervisor/SupervisorAgents.vue');
const SupervisorLiveCalls = () =>
  import('./pages/supervisor/SupervisorLiveCalls.vue');
const SupervisorMetrics = () =>
  import('./pages/supervisor/SupervisorMetrics.vue');
// TODO: reativar quando o dashboard manual for reformulado
// const AutoDialerDashboard = () =>
//   import('./pages/autodialer/AutoDialerDashboard.vue');
const AICampaignsList = () => import('./pages/autodialer/AICampaignsList.vue');
const AICampaignWizard = () =>
  import('./pages/autodialer/AICampaignWizard.vue');
const Step1DataSource = () =>
  import('./pages/autodialer/wizard/Step1DataSource.vue');
const Step2Config = () => import('./pages/autodialer/wizard/Step2Config.vue');
const Step3Schedule = () =>
  import('./pages/autodialer/wizard/Step3Schedule.vue');
const Step4Review = () => import('./pages/autodialer/wizard/Step4Review.vue');
const AutoDialerReports = () =>
  import('./pages/autodialer/AutoDialerReports.vue');
const AICampaignReport = () =>
  import('./pages/autodialer/AICampaignReport.vue');
const CallReportsList = () =>
  import('./pages/call-reports/CallReportsList.vue');
const TrunksList = () => import('./pages/trunks/TrunksList.vue');
const TrunkForm = () => import('./pages/trunks/TrunkForm.vue');
const HolidaysList = () => import('./pages/holidays/HolidaysList.vue');
const HolidayForm = () => import('./pages/holidays/HolidayForm.vue');

const meta = {
  permissions: ['administrator'],
};

// Chamadas, Relatório de Pausas e Monitor (Supervisor) também ficam
// acessíveis pra quem tem a permissão de custom role
// whatsapp_voice_reports_access — as demais rotas de WhatsApp Voice
// (ramais, filas, trunks, DIDs, IVR, feriados, autodialer) continuam só
// admin.
const reportsMeta = {
  permissions: ['administrator', 'whatsapp_voice_reports_access'],
};

const whatsappSipRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/extensions'),
      name: 'whatsapp_sip_extensions',
      meta,
      component: ExtensionsList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/extensions/new'),
      name: 'whatsapp_sip_extension_new',
      meta,
      component: ExtensionForm,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/extensions/:extensionId/edit'
      ),
      name: 'whatsapp_sip_extension_edit',
      meta,
      component: ExtensionForm,
      props: true,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/queues'),
      name: 'whatsapp_sip_queues',
      meta,
      component: QueuesList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/queues/new'),
      name: 'whatsapp_sip_queue_new',
      meta,
      component: QueueForm,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/queues/:queueId/edit'
      ),
      name: 'whatsapp_sip_queue_edit',
      meta,
      component: QueueForm,
      props: true,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/dids'),
      name: 'whatsapp_sip_dids',
      meta,
      component: DidsList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/dids/new'),
      name: 'whatsapp_sip_did_new',
      meta,
      component: DidForm,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/dids/:didId/edit'),
      name: 'whatsapp_sip_did_edit',
      meta,
      component: DidForm,
      props: true,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/trunks'),
      name: 'whatsapp_sip_trunks',
      meta,
      component: TrunksList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/trunks/new'),
      name: 'whatsapp_sip_trunk_new',
      meta,
      component: TrunkForm,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/trunks/:trunkId/edit'
      ),
      name: 'whatsapp_sip_trunk_edit',
      meta,
      component: TrunkForm,
      props: true,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/time-conditions'),
      name: 'whatsapp_sip_time_conditions',
      meta,
      component: TimeConditionsList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/supervisor'),
      name: 'whatsapp_sip_supervisor',
      meta: reportsMeta,
      component: SupervisorDashboard,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/supervisor/agents'),
      name: 'whatsapp_sip_supervisor_agents',
      meta: reportsMeta,
      component: SupervisorAgents,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/supervisor/live-calls'
      ),
      name: 'whatsapp_sip_supervisor_live_calls',
      meta: reportsMeta,
      component: SupervisorLiveCalls,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/supervisor/metrics'
      ),
      name: 'whatsapp_sip_supervisor_metrics',
      meta: reportsMeta,
      component: SupervisorMetrics,
    },
    // TODO: reativar quando o dashboard manual for reformulado
    // {
    //   path: frontendURL('accounts/:accountId/whatsapp-voice/autodialer'),
    //   name: 'whatsapp_sip_autodialer',
    //   meta,
    //   component: AutoDialerDashboard,
    // },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/autodialer/ai-campaigns'
      ),
      name: 'whatsapp_sip_autodialer_ai_campaigns',
      meta,
      component: AICampaignsList,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/autodialer/ai-campaigns/new'
      ),
      name: 'whatsapp_sip_autodialer_ai_campaign_new',
      component: AICampaignWizard,
      meta,
      redirect: { name: 'whatsapp_sip_ai_campaign_step_data' },
      children: [
        {
          path: 'data-source',
          name: 'whatsapp_sip_ai_campaign_step_data',
          component: Step1DataSource,
        },
        {
          path: 'config',
          name: 'whatsapp_sip_ai_campaign_step_config',
          component: Step2Config,
        },
        {
          path: 'schedule',
          name: 'whatsapp_sip_ai_campaign_step_schedule',
          component: Step3Schedule,
        },
        {
          path: 'review',
          name: 'whatsapp_sip_ai_campaign_step_review',
          component: Step4Review,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/autodialer/ai-campaigns/:campaignId/edit'
      ),
      name: 'whatsapp_sip_autodialer_ai_campaign_edit',
      component: AICampaignWizard,
      meta,
      props: true,
      redirect: { name: 'whatsapp_sip_ai_campaign_edit_step_data' },
      children: [
        {
          path: 'data-source',
          name: 'whatsapp_sip_ai_campaign_edit_step_data',
          component: Step1DataSource,
          props: true,
        },
        {
          path: 'config',
          name: 'whatsapp_sip_ai_campaign_edit_step_config',
          component: Step2Config,
          props: true,
        },
        {
          path: 'schedule',
          name: 'whatsapp_sip_ai_campaign_edit_step_schedule',
          component: Step3Schedule,
          props: true,
        },
        {
          path: 'review',
          name: 'whatsapp_sip_ai_campaign_edit_step_review',
          component: Step4Review,
          props: true,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/autodialer/ai-campaigns/:campaignId/report'
      ),
      name: 'whatsapp_sip_autodialer_ai_campaign_report',
      meta,
      component: AICampaignReport,
      props: true,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/autodialer/reports'
      ),
      name: 'whatsapp_sip_autodialer_reports',
      meta,
      component: AutoDialerReports,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/call-reports'),
      name: 'whatsapp_sip_call_reports',
      meta: reportsMeta,
      component: CallReportsList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/holidays'),
      name: 'whatsapp_sip_holidays',
      meta,
      component: HolidaysList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-voice/holidays/new'),
      name: 'whatsapp_sip_holiday_new',
      meta,
      component: HolidayForm,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-voice/holidays/:holidayId/edit'
      ),
      name: 'whatsapp_sip_holiday_edit',
      meta,
      component: HolidayForm,
      props: true,
    },
  ],
};

export default whatsappSipRoutes;
